@if (status === treatmentStatus.Complete) {
  <pr-icon-chip
    icon="check_circle"
    iconClass="text-green-500"
    matTooltipShowDelay="300"
    [matTooltip]="displayTooltip ? 'Treatment has been completed' : ''"
  >
    {{ treatmentStatus.Complete | titlecase }}
  </pr-icon-chip>
}

@if (status === treatmentStatus.Flagged) {
  <pr-icon-chip
    icon="flag_2"
    iconClass="text-warn-500"
    matTooltipShowDelay="300"
    [matTooltip]="
      displayTooltip
        ? 'Treatment flagged but not yet added to a treatment plan'
        : ''
    "
  >
    {{ treatmentStatus.Flagged | titlecase }}
  </pr-icon-chip>
}

@if (status === treatmentStatus.Planned) {
  <pr-icon-chip
    icon="edit_note"
    iconClass="text-amber-500"
    matTooltipShowDelay="300"
    [matTooltip]="
      displayTooltip
        ? 'Treatment is in a treatment plan but not yet completed'
        : ''
    "
  >
    {{ treatmentStatus.Planned | titlecase }}
  </pr-icon-chip>
}
